const LetterIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.334 0.333496H1.66732C0.933984 0.333496 0.340651 0.933496 0.340651 1.66683L0.333984 13.6668L3.00065 11.0002H12.334C13.0673 11.0002 13.6673 10.4002 13.6673 9.66683V1.66683C13.6673 0.933496 13.0673 0.333496 12.334 0.333496ZM3.66732 5.00016H10.334C10.7007 5.00016 11.0007 5.30016 11.0007 5.66683C11.0007 6.0335 10.7007 6.3335 10.334 6.3335H3.66732C3.30065 6.3335 3.00065 6.0335 3.00065 5.66683C3.00065 5.30016 3.30065 5.00016 3.66732 5.00016ZM7.66732 8.3335H3.66732C3.30065 8.3335 3.00065 8.0335 3.00065 7.66683C3.00065 7.30016 3.30065 7.00016 3.66732 7.00016H7.66732C8.03398 7.00016 8.33398 7.30016 8.33398 7.66683C8.33398 8.0335 8.03398 8.3335 7.66732 8.3335ZM10.334 4.3335H3.66732C3.30065 4.3335 3.00065 4.0335 3.00065 3.66683C3.00065 3.30016 3.30065 3.00016 3.66732 3.00016H10.334C10.7007 3.00016 11.0007 3.30016 11.0007 3.66683C11.0007 4.0335 10.7007 4.3335 10.334 4.3335Z"
      fill="#064C37"
    />
  </svg>
)

export default LetterIcon
